import {Layout} from '../../components/LayoutComponents';

export const ClassesPage: React.FC = () => {
  return <Layout pageTitle='Klassenverwaltung' paddingBottom></Layout>;
};
